export enum EntitiesType {
    VEHICLES = 'vehicles',
    PERSONS = 'persons',
}

export type EditableVehicleFormProperties = 'vehicles' | 'towVehicles';
export type EditablePersonFormProperties = 'involvedPersons' | 'reportingParties';
